import store from "../store";
import Constants from "../config/constants";
import {
  serviceCreateWhatsapp,
  serviceGetWhatsapp,
  serviceUpdateWhatsapp,
  serviceDeleteWhatsapp,
} from "../services/Whatsapp.service";
import EventEmitter from "../libs/Events.utils";

export const FETCH_INIT = "FETCH_INIT_WHATSAPP";
export const FETCHED = "FETCHED_WHATSAPP";
export const FETCHED_FAIL = "FETCHED_FAIL_WHATSAPP";
export const FETCHED_FILTER = "FETCHED_FILTER_WHATSAPP";
export const FETCH_NEXT = "FETCH_NEXT_WHATSAPP";
export const FILTER = "FILTER_WHATSAPP";
export const RESET_FILTER = "RESET_FILTER_WHATSAPP";
export const SET_SORTING = "SET_SORTING_WHATSAPP";
export const SET_FILTER = "SET_FILTER_WHATSAPP";
export const SET_PAGE = "SET_PAGE_WHATSAPP";
export const CHANGE_PAGE = "CHANGE_PAGE_WHATSAPP";
export const CHANGE_STATUS = "CHANGE_STATE_WHATSAPP";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_WHATSAPP";
export const CREATE_DATA = "CREATE_WHATSAPP";
export const UPDATE_DATA = "UPDATE_WHATSAPP";
export const DELETE_ITEM = "DELETE_WHATSAPP";
export const RESET_STATE = "RESET_STATE";

export function actionFetchWhatsapp(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetWhatsapp({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateWhatsapp(data) {
  const request = serviceCreateWhatsapp(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {
          error: "Saved",
          type: "success",
        });
        dispatch({ type: CREATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionUpdateWhatsapp(data) {
  const request = serviceUpdateWhatsapp(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: UPDATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionDeleteWhatsapp(id) {
  const request = serviceDeleteWhatsapp({ id: id });
  return (dispatch) => {
    dispatch({ type: DELETE_ITEM, payload: id });
  };
}

export function actionChangePageWhatsapp(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterWhatsapp(value) {
  const request = null; ////serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); //dispatch function
    });
  };
}

export function actionChangeStatusWhatsapp(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterWhatsapp() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}
export function actionResetWhatsappList() {
  return {
    type: RESET_STATE,
  };
}

export function actionSetPageWhatsapp(page) {
  const stateData = store.getState().whatsapp;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchWhatsapp(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
